var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-container",style:(`background-color: ${_vm.color}`)},[_c('Icons',{attrs:{"name":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"fs-14 fw-500 text-capitalize user-login"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }